import {
  convertCubicFootToCubicInch,
  convertCubicFootToCubicMeter,
  convertCubicFootToCubicMile,
  convertCubicFootToCubicYard,
  convertCubicFootToLiter
} from "./CubicFootConversion";
import {
  convertCubicInchToCubicFoot,
  convertCubicInchToCubicMeter,
  convertCubicInchToCubicMile,
  convertCubicInchToCubicYard,
  convertCubicInchToLiter
} from "./CubicInchConversion";
import {
  convertCubicMeterToCubicFoot,
  convertCubicMeterToCubicInch,
  convertCubicMeterToCubicMile,
  convertCubicMeterToCubicYard,
  convertCubicMeterToLiter
} from "./CubicMeterConversion";
import {
  convertCubicMileToLiter,
  convertCubicMileToCubicYard,
  convertCubicMileToCubicMeter,
  convertCubicMileToCubicInch,
  convertCubicMileToCubicFoot
} from "./CubicMileConversion";
import {
  convertCubicYardToLiter,
  convertCubicYardToCubicMile,
  convertCubicYardToCubicMeter,
  convertCubicYardToCubicInch,
  convertCubicYardToCubicFoot
} from "./CubicYardConversion";
import {
  convertLiterToCubicYard,
  convertLiterToCubicMile,
  convertLiterToCubicMeter,
  convertLiterToCubicInch,
  convertLiterToCubicFoot
} from "./LiterConversion";

function getFinalCubicFootConversion(val, conType) {
  let result = "";
  if (conType === "fttoin") {
    result = convertCubicFootToCubicInch(parseFloat(val));
  } else if (conType === "fttom") {
    result = convertCubicFootToCubicMeter(parseFloat(val));
  } else if (conType === "fttomi") {
    result = convertCubicFootToCubicMile(parseFloat(val));
  } else if (conType === "fttoyd") {
    result = convertCubicFootToCubicYard(parseFloat(val));
  } else if (conType === "fttol") {
    result = convertCubicFootToLiter(parseFloat(val));
  }
  return result;
}

function getFinalCubicInchConversion(val, conType) {
  let result = "";
  if (conType === "intoft") {
    result = convertCubicInchToCubicFoot(parseFloat(val));
  } else if (conType === "intom") {
    result = convertCubicInchToCubicMeter(parseFloat(val));
  } else if (conType === "intomi") {
    result = convertCubicInchToCubicMile(parseFloat(val));
  } else if (conType === "intoyd") {
    result = convertCubicInchToCubicYard(parseFloat(val));
  } else if (conType === "intol") {
    result = convertCubicInchToLiter(parseFloat(val));
  }

  return result;
}

function getFinalCubicMeterConversion(val, conType) {
  let result = "";
  if (conType === "mtoft") {
    result = convertCubicMeterToCubicFoot(parseFloat(val));
  } else if (conType === "mtoin") {
    result = convertCubicMeterToCubicInch(parseFloat(val));
  } else if (conType === "mtomi") {
    result = convertCubicMeterToCubicMile(parseFloat(val));
  } else if (conType === "mtoyd") {
    result = convertCubicMeterToCubicYard(parseFloat(val));
  } else if (conType === "mtol") {
    result = convertCubicMeterToLiter(parseFloat(val));
  }

  return result;
}

function getFinalCubicMileConversion(val, conType) {
  let result = "";
  if (conType === "mitol") {
    result = convertCubicMileToLiter(parseFloat(val));
  } else if (conType === "mitoyd") {
    result = convertCubicMileToCubicYard(parseFloat(val));
  } else if (conType === "mitom") {
    result = convertCubicMileToCubicMeter(parseFloat(val));
  } else if (conType === "mitoin") {
    result = convertCubicMileToCubicInch(parseFloat(val));
  } else if (conType === "mitoft") {
    result = convertCubicMileToCubicFoot(parseFloat(val));
  }

  return result;
}

function getFinalCubicYardConversion(val, conType) {
  let result = "";
  if (conType === "ydtol") {
    result = convertCubicYardToLiter(parseFloat(val));
  } else if (conType === "ydtomi") {
    result = convertCubicYardToCubicMile(parseFloat(val));
  } else if (conType === "ydtom") {
    result = convertCubicYardToCubicMeter(parseFloat(val));
  } else if (conType === "ydtoin") {
    result = convertCubicYardToCubicInch(parseFloat(val));
  } else if (conType === "ydtoft") {
    result = convertCubicYardToCubicFoot(parseFloat(val));
  }

  return result;
}

function getFinalLiterConversion(val, conType) {
  let result = "";
  if (conType === "ltoyd") {
    result = convertLiterToCubicYard(parseFloat(val));
  } else if (conType === "ltomi") {
    result = convertLiterToCubicMile(parseFloat(val));
  } else if (conType === "ltom") {
    result = convertLiterToCubicMeter(parseFloat(val));
  } else if (conType === "ltoin") {
    result = convertLiterToCubicInch(parseFloat(val));
  } else if (conType === "ltoft") {
    result = convertLiterToCubicFoot(parseFloat(val));
  }

  return result;
}

export {
  getFinalLiterConversion,
  getFinalCubicYardConversion,
  getFinalCubicMileConversion,
  getFinalCubicMeterConversion,
  getFinalCubicInchConversion,
  getFinalCubicFootConversion
};
